import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { ProtectedRoute } from './ProtectedRoute';
import { AppLayout } from '../components/layout/AppLayout';
import { LoginPage } from '../pages/auth/LoginPage';
import { DashboardPage } from '../pages/dashboard/DashboardPage';
import { ForbiddenPage } from '../pages/ForbiddenPage';
import { EpcMilestonesPage } from '../pages/epc/EpcMilestonesPage';
import { EpcHandoversPage } from '../pages/epc/EpcHandoversPage';
import { EpcBoqPage } from '../pages/epc/EpcBoqPage';
import { EpcDashboardPage } from '../pages/epc/EpcDashboardPage';
import { EpcClosuresPage } from '../pages/epc/EpcClosuresPage';
import { EpcSiteMonitoringPage } from '../pages/epc/EpcSiteMonitoringPage';
import { EpcRequisitionsPage } from '../pages/epc/EpcRequisitionsPage';
import { EpcProcurementReviewPage } from '../pages/epc/EpcProcurementReviewPage';
import { EpcDiscomPage } from '../pages/epc/EpcDiscomPage';
import { EpcPaymentApprovalsPage } from '../pages/epc/EpcPaymentApprovalsPage';
import { EpcRfqPage } from '../pages/epc/EpcRfqPage';
import { EpcRfqPurchaseOrdersPage } from '../pages/epc/EpcRfqPurchaseOrdersPage';
import { EpcPurchaseOrdersPage } from '../pages/epc/EpcPurchaseOrdersPage';
import { EpcWorkOrdersPage } from '../pages/epc/EpcWorkOrdersPage';
import { EpcInvoicesPage } from '../pages/epc/EpcInvoicesPage';
import { EpcPaymentsPage } from '../pages/epc/EpcPaymentsPage';
import { AssetRegisterPage } from '../pages/asset-management/AssetRegisterPage';
import { AssetTransfersPage } from '../pages/asset-management/AssetTransfersPage';
import { CmsPage } from '../pages/asset-management/CmsPage';
import { CmsConnectionsPage } from '../pages/asset-management/CmsConnectionsPage';
import { StationsPage } from '../pages/asset-management/StationsPage';
import { RentPage } from '../pages/asset-management/RentPage';
import { AgreementsPage } from '../pages/asset-management/AgreementsPage';
import { ElectricityPage } from '../pages/asset-management/ElectricityPage';
import { AmDashboardPage } from '../pages/asset-management/AmDashboardPage';
import { AmAnalyticsPage } from '../pages/asset-management/AmAnalyticsPage';
import { AmPaymentsPage } from '../pages/asset-management/AmPaymentsPage';
import { ComplaintsPage } from '../pages/repair-maintenance/ComplaintsPage';
import { VerticalAccessPage } from '../pages/admin/VerticalAccessPage';
import { VerticalGoLivePage } from '../pages/admin/VerticalGoLivePage';
import { TeamPerformancePage } from '../pages/admin/TeamPerformancePage';
import { UserListPage } from '../pages/users/UserListPage';
import { RoleListPage } from '../pages/roles/RoleListPage';
import { ClientListPage } from '../pages/clients/ClientListPage';
import { ProjectListPage } from '../pages/projects/ProjectListPage';
import { SiteListPage } from '../pages/sites/SiteListPage';
import { OmsListPage } from '../pages/oms/OmsListPage';
import { CategoryListPage } from '../pages/boq-masters/CategoryListPage';
import { TemplateListPage } from '../pages/boq-masters/TemplateListPage';
import { RateCardListPage } from '../pages/boq-masters/RateCardListPage';
import { BoqUploadPage } from '../pages/boq-masters/BoqUploadPage';
import { ManufacturerPriceListsPage } from '../pages/boq-masters/ManufacturerPriceListsPage';
import { RateLookupPage } from '../pages/boq-masters/RateLookupPage';
import { BoqPurchasesPage } from '../pages/boq-masters/BoqPurchasesPage';
import { BoqListPage } from '../pages/boq/BoqListPage';
import { ProcurementDashboardPage } from '../pages/procurement/ProcurementDashboardPage';
import { PrListPage } from '../pages/procurement/PrListPage';
import { RfqListPage } from '../pages/procurement/RfqListPage';
import { PoListPage } from '../pages/procurement/PoListPage';
import { WorkOrderListPage } from '../pages/work-orders/WorkOrderListPage';
import { FinanceDashboardPage } from '../pages/finance/FinanceDashboardPage';
import { InvoiceListPage } from '../pages/finance/InvoiceListPage';
import { PaymentListPage } from '../pages/finance/PaymentListPage';
import { MyApprovalsPage } from '../pages/engine/MyApprovalsPage';
import { ApprovalMatrixPage } from '../pages/engine/ApprovalMatrixPage';
import { EmailTemplatesPage } from '../pages/engine/EmailTemplatesPage';
import { EmailLogsPage } from '../pages/engine/EmailLogsPage';
import { EmailSettingsPage } from '../pages/engine/EmailSettingsPage';
import { AiSettingsPage } from '../pages/settings/AiSettingsPage';
import { WhatsAppSettingsPage } from '../pages/whatsapp/WhatsAppSettingsPage';
import { WhatsAppTemplatesPage } from '../pages/whatsapp/WhatsAppTemplatesPage';
import { WhatsAppLogsPage } from '../pages/whatsapp/WhatsAppLogsPage';
import { SecuritySettingsPage } from '../pages/security/SecuritySettingsPage';
import { SecurityDashboardPage } from '../pages/security/SecurityDashboardPage';
import { NotificationsPage } from '../pages/engine/NotificationsPage';
import { ProfitabilityDashboardPage } from '../pages/profitability/ProfitabilityDashboardPage';
import { PnlPage } from '../pages/profitability/PnlPage';
import { TargetsPage } from '../pages/profitability/TargetsPage';
import { ProfitEntriesPage } from '../pages/profitability/ProfitEntriesPage';
import { InventoryDashboardPage } from '../pages/inventory/InventoryDashboardPage';
import { WarehousesPage } from '../pages/inventory/WarehousesPage';
import { ItemsPage } from '../pages/inventory/ItemsPage';
import { StockLedgerPage } from '../pages/inventory/StockLedgerPage';
import { AssetTrackingPage } from '../pages/inventory/AssetTrackingPage';
import { PurchasesPage } from '../pages/inventory/PurchasesPage';
import { FieldMobilePage } from '../pages/field/FieldMobilePage';
import { AmcDashboardPage } from '../pages/amc/AmcDashboardPage';
import { AssetsPage } from '../pages/amc/AssetsPage';
import { ContractsPage } from '../pages/amc/ContractsPage';
import { TicketsPage } from '../pages/amc/TicketsPage';
import { CustomerPortalPage } from '../pages/amc/CustomerPortalPage';
import { PlatformDashboardPage } from '../pages/platform/PlatformDashboardPage';
import { TenantsPage } from '../pages/platform/TenantsPage';
import { PlansPage } from '../pages/platform/PlansPage';
import { VendorListPage } from '../pages/vendors/VendorListPage';
import { TechnicianListPage } from '../pages/technicians/TechnicianListPage';
import { EmployeeListPage } from '../pages/employees/EmployeeListPage';
import { MaterialListPage } from '../pages/materials/MaterialListPage';
import { LabourRateListPage } from '../pages/labour-rates/LabourRateListPage';
import { DealerListPage } from '../pages/evcpd/dealers/DealerListPage';
import { DealerDashboardPage } from '../pages/evcpd/DealerDashboardPage';
import { DealerPaymentReconciliationPage } from '../pages/evcpd/DealerPaymentReconciliationPage';
import { ProductListPage } from '../pages/evcpd/products/ProductListPage';
import { OrderListPage } from '../pages/evcpd/orders/OrderListPage';
import { OrderAnalyticsDashboardPage } from '../pages/evcpd/OrderAnalyticsDashboardPage';
import { ProductionPlanListPage } from '../pages/evcpd/production/ProductionPlanListPage';
import { StockHandoverPage } from '../pages/evcpd/production/StockHandoverPage';
import { ProductionDashboardPage } from '../pages/evcpd/ProductionDashboardPage';
import { InstallationListPage } from '../pages/evcpd/installations/InstallationListPage';
import { InstallationDashboardPage } from '../pages/evcpd/InstallationDashboardPage';
import { ServiceTicketListPage } from '../pages/evcpd/service/ServiceTicketListPage';
import { ServiceDashboardPage } from '../pages/evcpd/ServiceDashboardPage';
import { AmcContractListPage } from '../pages/evcpd/amc/AmcContractListPage';
import { AmcDashboardPage as EvcpdAmcDashboardPage } from '../pages/evcpd/AmcDashboardPage';
import { ChecklistTemplatesPage } from '../pages/evcpd/amc/ChecklistTemplatesPage';
import { PmExecutionPage } from '../pages/evcpd/amc/PmExecutionPage';
import { AmcReportsPage } from '../pages/evcpd/amc/AmcReportsPage';
import { IntegrationDashboardPage } from '../pages/integration/IntegrationDashboardPage';
import { IntegrationsPage } from '../pages/integration/IntegrationsPage';
import { ApiKeysPage } from '../pages/integration/ApiKeysPage';
import { IntegrationLogsPage } from '../pages/integration/IntegrationLogsPage';
import { WebhooksPage } from '../pages/integration/WebhooksPage';
import { FailedQueuePage } from '../pages/integration/FailedQueuePage';
import { MarketplacePage } from '../pages/integration/MarketplacePage';
import { MonitoringPage } from '../pages/integration/MonitoringPage';
import { DocsPage } from '../pages/integration/DocsPage';
import { VendorOnboardingWizard } from '../pages/vendors/onboarding/VendorOnboardingWizard';
import { VendorApplicationsPage } from '../pages/vendors/onboarding/VendorApplicationsPage';
import { VendorOnboardingDashboardPage } from '../pages/vendors/onboarding/VendorOnboardingDashboardPage';
import { ClientApplicationsPage } from '../pages/clients/onboarding/ClientApplicationsPage';
import { ClientOnboardingForm } from '../pages/clients/onboarding/ClientOnboardingForm';
import { ClientOnboardingDashboardPage } from '../pages/clients/onboarding/ClientOnboardingDashboardPage';
import { ProjectApplicationsPage } from '../pages/projects/onboarding/ProjectApplicationsPage';
import { ProjectOnboardingForm } from '../pages/projects/onboarding/ProjectOnboardingForm';
import { ProjectOnboardingDashboardPage } from '../pages/projects/onboarding/ProjectOnboardingDashboardPage';
import { SiteApplicationsPage } from '../pages/sites/onboarding/SiteApplicationsPage';
import { SiteOnboardingForm } from '../pages/sites/onboarding/SiteOnboardingForm';
import { SiteOnboardingDashboardPage } from '../pages/sites/onboarding/SiteOnboardingDashboardPage';
import { TechnicianApplicationsPage } from '../pages/technicians/onboarding/TechnicianApplicationsPage';
import { TechnicianOnboardingForm } from '../pages/technicians/onboarding/TechnicianOnboardingForm';
import { TechnicianOnboardingDashboardPage } from '../pages/technicians/onboarding/TechnicianOnboardingDashboardPage';
import { ClientMappingsPage } from '../pages/evcpd/ClientMappingsPage';
import { ManufacturersPage } from '../pages/sourcing/ManufacturersPage';
import { ManufacturingOrdersPage } from '../pages/sourcing/ManufacturingOrdersPage';
import { ManufacturerPaymentsPage } from '../pages/sourcing/ManufacturerPaymentsPage';
import { DispatchPage } from '../pages/fulfilment/DispatchPage';
import { DeliveryPage } from '../pages/fulfilment/DeliveryPage';
import { PdiHomePage } from '../pages/pdi/PdiHomePage';
import { DeepAnalyticsPage } from '../pages/pdi/DeepAnalyticsPage';
import { DealerMappingPage } from '../pages/insights/DealerMappingPage';
import { DealerTargetsPage } from '../pages/insights/DealerTargetsPage';
import { DealerApplicationsPage } from '../pages/pdi/dealerOnboarding/DealerApplicationsPage';
import { PublicDealerRegistrationPage } from '../pages/pdi/dealerOnboarding/PublicDealerRegistrationPage';
import { DealerFinancePage } from '../pages/evcpd/DealerFinancePage';
import { AgeingReportPage } from '../pages/evcpd/AgeingReportPage';
import { ClientPortalDashboardPage } from '../pages/evcpd/ClientPortalDashboardPage';
import { ClientFinancePage } from '../pages/evcpd/ClientFinancePage';
import { ClientOrderPage } from '../pages/evcpd/ClientOrderPage';

/**
 * Application route tree. Phase 1 module pages (users, clients, projects, sites)
 * mount under the protected AppLayout as they are implemented.
 */
/** Role-aware landing: client portal users land on their Asset Management dashboard
 *  (the cross-module Dashboard is staff-oriented and shows nothing useful to a client). */
function HomeRedirect() {
  const { user } = useAuth();
  // Portal users land on their own dashboard (by linked entity, so custom roles work too):
  // AM clients → Asset Management, PDI clients → their PDI dashboard, dealers → PDI home;
  // everyone else → the cross-module dashboard.
  const t = user?.linkedEntityType;
  const isAmClient = (user?.permissions ?? []).includes('am_station.read');
  const path = t === 'client' ? (isAmClient ? '/asset-management/dashboard' : '/pdi/my-dashboard')
    : t === 'dealer' ? '/pdi/home' : '/dashboard';
  return <Navigate to={path} replace />;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forbidden" element={<ForbiddenPage />} />
      {/* Public PDI dealer/partner self-registration (no login required). */}
      <Route path="/register/dealer" element={<PublicDealerRegistrationPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/users" element={<UserListPage />} />
          <Route path="/roles" element={<RoleListPage />} />
          <Route path="/clients" element={<ClientListPage />} />
          <Route path="/projects" element={<ProjectListPage />} />
          <Route path="/sites" element={<SiteListPage />} />
          <Route path="/oms" element={<OmsListPage />} />
          <Route path="/boqs" element={<BoqListPage />} />
          <Route path="/boq-categories" element={<CategoryListPage kind="boq" />} />
          <Route path="/sow-categories" element={<CategoryListPage kind="sow" />} />
          <Route path="/boq-templates" element={<TemplateListPage />} />
          <Route path="/rate-cards" element={<RateCardListPage />} />
          <Route path="/boq-upload" element={<BoqUploadPage />} />
          <Route path="/manufacturer-price-lists" element={<ManufacturerPriceListsPage />} />
          <Route path="/rate-lookup" element={<RateLookupPage />} />
          <Route path="/boq-purchases" element={<BoqPurchasesPage />} />
          <Route path="/procurement" element={<ProcurementDashboardPage />} />
          <Route path="/purchase-requisitions" element={<PrListPage />} />
          <Route path="/rfqs" element={<RfqListPage />} />
          <Route path="/purchase-orders" element={<PoListPage />} />
          <Route path="/work-orders" element={<WorkOrderListPage />} />
          <Route path="/finance" element={<FinanceDashboardPage />} />
          <Route path="/invoices" element={<InvoiceListPage />} />
          <Route path="/payments" element={<PaymentListPage />} />
          <Route path="/my-approvals" element={<MyApprovalsPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/approval-matrix" element={<ApprovalMatrixPage />} />
          <Route path="/email-templates" element={<EmailTemplatesPage />} />
          <Route path="/email-logs" element={<EmailLogsPage />} />
          <Route path="/email-settings" element={<EmailSettingsPage />} />
          <Route path="/ai-settings" element={<AiSettingsPage />} />
          <Route path="/whatsapp" element={<WhatsAppLogsPage />} />
          <Route path="/whatsapp-templates" element={<WhatsAppTemplatesPage />} />
          <Route path="/whatsapp-settings" element={<WhatsAppSettingsPage />} />
          <Route path="/security" element={<SecurityDashboardPage />} />
          <Route path="/security-settings" element={<SecuritySettingsPage />} />
          <Route path="/vendors" element={<VendorListPage />} />
          <Route path="/technicians" element={<TechnicianListPage />} />
          <Route path="/employees" element={<EmployeeListPage />} />
          <Route path="/materials" element={<MaterialListPage />} />
          <Route path="/labour-rates" element={<LabourRateListPage />} />
          <Route path="/profitability" element={<ProfitabilityDashboardPage />} />
          <Route path="/pnl" element={<PnlPage />} />
          <Route path="/targets" element={<TargetsPage />} />
          <Route path="/profit-entries" element={<ProfitEntriesPage />} />
          <Route path="/inventory" element={<InventoryDashboardPage />} />
          <Route path="/warehouses" element={<WarehousesPage />} />
          <Route path="/inventory-items" element={<ItemsPage />} />
          <Route path="/inventory-purchases" element={<PurchasesPage />} />
          <Route path="/stock-ledger" element={<StockLedgerPage />} />
          <Route path="/asset-tracking" element={<AssetTrackingPage />} />
          <Route path="/field" element={<FieldMobilePage />} />
          <Route path="/service-analytics" element={<AmcDashboardPage />} />
          <Route path="/service-assets" element={<AssetsPage />} />
          <Route path="/amc-contracts" element={<ContractsPage />} />
          <Route path="/service-tickets" element={<TicketsPage />} />
          <Route path="/customer-portal" element={<CustomerPortalPage />} />
          <Route path="/evcpd/dealers/dashboard" element={<DealerDashboardPage />} />
          <Route path="/evcpd/dealers" element={<DealerListPage />} />
          <Route path="/evcpd/dealer-payments" element={<DealerPaymentReconciliationPage />} />
          <Route path="/evcpd/products" element={<ProductListPage />} />
          <Route path="/evcpd/orders" element={<OrderListPage />} />
          {/* Spec menu aliases (Place Order / Order Confirmation) — reuse the Orders hub. */}
          <Route path="/evcpd/orders/place" element={<OrderListPage />} />
          <Route path="/evcpd/orders/confirm" element={<OrderListPage />} />
          <Route path="/evcpd/order-analytics" element={<OrderAnalyticsDashboardPage />} />
          <Route path="/evcpd/production" element={<ProductionPlanListPage />} />
          <Route path="/evcpd/stock-handovers" element={<StockHandoverPage />} />
          <Route path="/evcpd/production-dashboard" element={<ProductionDashboardPage />} />
          <Route path="/evcpd/installations" element={<InstallationListPage />} />
          <Route path="/evcpd/installation-dashboard" element={<InstallationDashboardPage />} />
          <Route path="/evcpd/service-tickets" element={<ServiceTicketListPage />} />
          <Route path="/evcpd/service-dashboard" element={<ServiceDashboardPage />} />
          <Route path="/evcpd/amc" element={<AmcContractListPage />} />
          <Route path="/evcpd/amc-dashboard" element={<EvcpdAmcDashboardPage />} />
          <Route path="/evcpd/checklist-templates" element={<ChecklistTemplatesPage />} />
          <Route path="/evcpd/pm-execution" element={<PmExecutionPage />} />
          <Route path="/evcpd/amc-reports" element={<AmcReportsPage />} />
          <Route path="/integrations/dashboard" element={<IntegrationDashboardPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/integrations/api-keys" element={<ApiKeysPage />} />
          <Route path="/integrations/logs" element={<IntegrationLogsPage />} />
          <Route path="/integrations/webhooks" element={<WebhooksPage />} />
          <Route path="/integrations/failed-queue" element={<FailedQueuePage />} />
          <Route path="/integrations/marketplace" element={<MarketplacePage />} />
          <Route path="/integrations/monitoring" element={<MonitoringPage />} />
          <Route path="/integrations/docs" element={<DocsPage />} />
          <Route path="/vendor-portal/onboarding" element={<VendorOnboardingWizard />} />
          <Route path="/vendor-applications/:id/edit" element={<VendorOnboardingWizard />} />
          <Route path="/vendor-applications" element={<VendorApplicationsPage />} />
          <Route path="/vendor-onboarding-dashboard" element={<VendorOnboardingDashboardPage />} />
          <Route path="/client-applications" element={<ClientApplicationsPage />} />
          <Route path="/client-applications/:id/edit" element={<ClientOnboardingForm />} />
          <Route path="/client-onboarding-dashboard" element={<ClientOnboardingDashboardPage />} />
          <Route path="/project-applications" element={<ProjectApplicationsPage />} />
          <Route path="/project-applications/:id/edit" element={<ProjectOnboardingForm />} />
          <Route path="/project-onboarding-dashboard" element={<ProjectOnboardingDashboardPage />} />
          <Route path="/site-applications" element={<SiteApplicationsPage />} />
          <Route path="/site-applications/:id/edit" element={<SiteOnboardingForm />} />
          <Route path="/site-onboarding-dashboard" element={<SiteOnboardingDashboardPage />} />
          <Route path="/technician-applications" element={<TechnicianApplicationsPage />} />
          <Route path="/technician-applications/:id/edit" element={<TechnicianOnboardingForm />} />
          <Route path="/technician-onboarding-dashboard" element={<TechnicianOnboardingDashboardPage />} />
          <Route path="/pdi/client-mappings" element={<ClientMappingsPage />} />
          {/* SOURCING (Manufacturers) */}
          <Route path="/sourcing/manufacturers" element={<ManufacturersPage />} />
          <Route path="/sourcing/manufacturers/onboard" element={<ManufacturersPage />} />
          <Route path="/sourcing/manufacturing-orders" element={<ManufacturingOrdersPage />} />
          <Route path="/sourcing/daily-commitment" element={<ManufacturingOrdersPage />} />
          <Route path="/sourcing/payments" element={<ManufacturerPaymentsPage />} />
          <Route path="/pdi/home" element={<PdiHomePage />} />
          <Route path="/pdi/analytics" element={<DeepAnalyticsPage />} />
          <Route path="/insights/dealer-mapping" element={<DealerMappingPage />} />
          <Route path="/insights/dealer-targets" element={<DealerTargetsPage />} />
          <Route path="/pdi/dealer-applications" element={<DealerApplicationsPage />} />
          {/* FULFILMENT */}
          <Route path="/fulfilment/dispatch" element={<DispatchPage />} />
          <Route path="/fulfilment/delivery" element={<DeliveryPage />} />
          <Route path="/pdi/dealer-finance" element={<DealerFinancePage />} />
          {/* Spec menu alias (Ageing Report) — reuses the dealer finance / invoice page. */}
          <Route path="/pdi/ageing" element={<AgeingReportPage />} />
          <Route path="/pdi/my-dashboard" element={<ClientPortalDashboardPage />} />
          <Route path="/pdi/my-orders" element={<ClientOrderPage />} />
          <Route path="/pdi/my-finance" element={<ClientFinancePage />} />
          <Route path="/epc/dashboard" element={<EpcDashboardPage />} />
          <Route path="/epc/closures" element={<EpcClosuresPage />} />
          <Route path="/epc/site-monitoring" element={<EpcSiteMonitoringPage />} />
          <Route path="/epc/boq" element={<EpcBoqPage />} />
          <Route path="/epc/requisitions" element={<EpcRequisitionsPage />} />
          <Route path="/epc/procurement-review" element={<EpcProcurementReviewPage />} />
          <Route path="/epc/discom" element={<EpcDiscomPage />} />
          <Route path="/epc/payment-approvals" element={<EpcPaymentApprovalsPage />} />
          <Route path="/epc/rfq" element={<EpcRfqPage />} />
          <Route path="/epc/rfq-purchase-orders" element={<EpcRfqPurchaseOrdersPage />} />
          <Route path="/epc/purchase-orders" element={<EpcPurchaseOrdersPage />} />
          <Route path="/epc/work-orders" element={<EpcWorkOrdersPage />} />
          <Route path="/epc/invoices" element={<EpcInvoicesPage />} />
          <Route path="/epc/payments" element={<EpcPaymentsPage />} />
          <Route path="/epc/milestones" element={<EpcMilestonesPage />} />
          <Route path="/epc/handovers" element={<EpcHandoversPage />} />
          <Route path="/asset-management/dashboard" element={<AmDashboardPage />} />
          <Route path="/asset-management/analytics" element={<AmAnalyticsPage />} />
          <Route path="/asset-management/stations" element={<StationsPage />} />
          <Route path="/asset-management/rent" element={<RentPage />} />
          <Route path="/asset-management/agreements" element={<AgreementsPage />} />
          <Route path="/asset-management/electricity" element={<ElectricityPage />} />
          <Route path="/asset-management/payments" element={<AmPaymentsPage />} />
          <Route path="/asset-management/assets" element={<AssetRegisterPage />} />
          <Route path="/asset-management/transfers" element={<AssetTransfersPage />} />
          <Route path="/asset-management/cms" element={<CmsPage />} />
          <Route path="/asset-management/cms-connections" element={<CmsConnectionsPage />} />
          <Route path="/repair-maintenance/complaints" element={<ComplaintsPage />} />
          <Route path="/admin/vertical-access" element={<VerticalAccessPage />} />
          <Route path="/admin/vertical-go-live" element={<VerticalGoLivePage />} />
          <Route path="/admin/team-performance" element={<TeamPerformancePage />} />
          <Route path="/platform" element={<PlatformDashboardPage />} />
          <Route path="/platform/tenants" element={<TenantsPage />} />
          <Route path="/platform/plans" element={<PlansPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
